import type { LucideIcon } from 'lucide-react';
import type { ReactElement } from 'react';
import { HoverCard, HoverCardContent, HoverCardPortal, HoverCardTrigger } from '@artstorefronts/ui';

export function HoverExplainer({
  enabled = true,
  icon: Icon,
  title,
  text,
  children,
}: {
  enabled?: boolean;
  icon: LucideIcon;
  title: string;
  text: string;
  children: ReactElement;
}) {
  if (!enabled) return children;

  return (
    <HoverCard openDelay={150} closeDelay={100}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardPortal>
        <HoverCardContent
          side="top"
          sideOffset={8}
          className="z-[100] w-72 p-0 overflow-hidden border text-gray-800 shadow-md"
          style={{
            background: '#ffffff linear-gradient(to bottom right, #eef2ff, #ffffff)',
            borderColor: 'rgb(199 210 254 / 0.7)',
          }}
        >
          <div
            className="flex items-center gap-1.5 px-4 pt-3 pb-1.5 text-sm font-semibold"
            style={{ color: '#4338ca' }}
          >
            <Icon className="shrink-0" style={{ width: 12, height: 12 }} aria-hidden />
            <span>{title}</span>
          </div>
          <p className="px-4 pb-3 text-sm" style={{ color: '#374151' }}>
            {text}
          </p>
        </HoverCardContent>
      </HoverCardPortal>
    </HoverCard>
  );
}
